module.exports = __webpack_public_path__ + "static/media/custom-subscriptions.34e97068.png";